import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { RouterOutlet } from "@angular/router";
import { tryHandleDigilockerKycReturnOnLoad } from "@los-workspace/common-lib";
import { initFlowbite } from "flowbite";
import { LosInputDirectivesModule } from "@shared/directives/los-input-directives.module";

@Component({
  selector: "app-root",
  standalone: true,
  imports: [RouterOutlet, LosInputDirectivesModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: "<router-outlet></router-outlet>",
})
export class AppComponent implements OnInit {
  ngOnInit(): void {
    tryHandleDigilockerKycReturnOnLoad();
    initFlowbite();
  }
}
